export default "__VITE_ASSET__199c1e2f__"